<template>
  <prod-page>
    <el-row style="width: 100%;text-align: left;">
      <el-carousel v-if="data !== ''" :interval="4000" :autoplay="false" trigger="click" arrow="always" height="430px" indicator-position="none">
        <el-carousel-item v-for="(item, i) in data" :key="i">
          <el-row style="height: 160px;margin-top: 10px;">
            <el-row style="width: 94%;margin-left: 3%;height: 100%;display: flex;">
              <el-image :src="item.image" class="img-class" fit="contain"></el-image>
              <el-row style="width: 50%;height: 100%;text-align: left;display: flex;flex-direction: column;justify-content: center;">
                <el-row class="model-class-ext">{{item.model}}</el-row>
                <el-row class="text-class">{{item.name}}</el-row>
              </el-row>
            </el-row>
          </el-row>
          <el-row class="detail-class">
            <div v-for="(detail, index) in item.detail" :key="index">{{detail}}</div>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </el-row>
  </prod-page>
</template>

<script>
import ProdPage from './ProdPage'
export default {
  name: 'Hardware',
  components: {ProdPage},
  props: {
    'selId': {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDetail: false,
      dataList: [
        {
          id: '321',
          param: 'meter',
          name: '仪表类',
          data: [
            {
              id: '3211',
              model: 'YK-8100',
              name: '智能能效采集终端',
              image: require('../../assets/img/hardware/yk8100.png'),
              detail: ['全电量监测：三相电压、三相电流、剩余电流、功率、电量、功率因素、频率;',
                '电能质量监测：2-31次谐波、奇次/偶次/总谐波畸变率、不平衡度',
                '支持开口CT或穿刺CT，免停电安装',
                '支持4路温度测量、2路开关量采集、2路开关量输出',
                '多种通信方式：RS485（默认）、微功率无线/4G/GPRS/LoRa（可选）']
            },
            {
              id: '3212',
              model: 'YK-8210',
              name: '三相智能电表',
              image: require('../../assets/img/hardware/yk8210.png'),
              detail: ['全电量监测、0.5S级高精度电能计量',
                '额定电流1/5/10A可选，测量范围6/60/80A',
                '分时计费、需量、谐波、定值越限\n',
                '多路输入输出\n',
                '多种通信方式：RS485（默认）、红外（默认）、微功率无线/4G/GPRS/LoRa（可选）']
            },
            {
              id: '3213',
              model: 'YK-8220',
              name: '单相智能电表',
              image: require('../../assets/img/hardware/yk8220.png'),
              detail: ['全电量监测、1级高精度电能计量',
                '额定电流5A，最大测量范围60A',
                '分时计费、需量、谐波、定值越限',
                '多路输入输出',
                '多种通信方式：RS485（默认）、红外（默认）、微功率无线/4G/GPRS/LoRa（可选）']
            },
            {
              id: '3214',
              model: 'YK-8300',
              name: '直流电表',
              image: require('../../assets/img/hardware/yk8300.png'),
              detail: ['1级高精度电能计量',
                '参比电压Un：100V、500V、700V、1000V',
                '直流分流器输出电压： 75mV',
                '多种通信方式：RS485（默认）、红外（默认）、微功率无线/4G/GPRS/LoRa（可选）']
            },
            {
              id: '3215',
              model: 'YK-8400',
              name: '负荷识别终端',
              image: require('../../assets/img/hardware/yk8400.png'),
              detail: ['电压、电流、功率、功率因素、频率监测',
                '电压电流测量精度±0.5%、电能计量精度±1%',
                '单一电器识别准确度＞90%，混合电器识别准确度＞80%',
                '单一电器计量准确度＞80%，混合电器计量准确度＞70%',
                '多种通信方式：RS485（默认）、WIFI/4G/GPRS/LoRa/ZigBee/蓝牙（可选）']
            },
            {
              id: '3216',
              model: 'YK-8500',
              name: '智能微断',
              image: require('../../assets/img/hardware/yk8500.png'),
              detail: ['电压、电流、漏电流实时监测、电量计量',
                '支持本地漏电自检、手机操作漏电自检、漏电自动自检',
                '支持短路保护、漏电保护、过流保护、过压保护、过温保护',
                '支持欠压报警、过压报警、打火断电报警',
                '额定电压220V、额定电流16/20/32/40/63/80/100A可选',
                '漏电30mA，≤0.1s断路保护',
                '支持本地手动/电机控制、远程手机控制',
                '机械寿命≥60000次',
                '多种通信方式：RS485（默认）、WIFI/4G/',
                'GPRS/LoRa/ZigBee/蓝牙（可选）']
            },
            {
              id: '3217',
              model: 'YK-8600',
              name: '物联网智能断路器',
              image: require('../../assets/img/hardware/yk8600.png'),
              detail: ['电压、电流、剩余电流实时监测、电量计量',
                '采用测量与保护CT，动作可靠、精度高',
                '剩余电流保护，剩余电流档位可在线整定，具有重合闸功能',
                '支持短路保护、漏电保护、过流保护、过压保护、欠压保护、缺相保护、过温保护',
                '长延时、短延时和瞬时三段保护，采用电子式脱扣，与电源电压无关',
                '具有高分断能力，保证线路短路保护的可靠性；',
                '线路剩余电流、三相电源电压、负荷电流、功率、电量实时显示',
                '保护功能及参数可在线设置修改',
                '跳闸类型（剩余电流、闭锁、过载、欠压、过压、缺相）识别、显示，并可存储、查询、删除',
                '额定电压380V、壳架电流125/250/400/630/800A可选',
                '支持本地/远程分合闸',
                '通信方式：RS485（默认）、4G/GPRS/LoRa/ZigBee/蓝牙/微功率无线（可选）',
                '定位对时功能可选：GPS/BD双模']
            }
          ]
        },
        {
          id: '322',
          param: 'sensor',
          name: '传感类',
          data: [
            {
              id: '3221',
              model: 'YK-9100',
              name: '开口式互感器',
              image: require('../../assets/img/hardware/yk9100.png'),
              detail: ['开口铁芯结构设计，免停电安装',
                '0.5级测量精度、相位线性误差≤30′',
                '初级线圈5—400Aac可选，次级电压/电流输出可选、孔径5—35mm可选',
                '50—1KHz工作频率、-25℃—50℃工作温度']
            },
            {
              id: '3222',
              model: 'YK-9200',
              name: '系列无线测温装置',
              image: require('../../assets/img/hardware/yk9200.png'),
              detail: ['汇集单元最大支持45个无线传感单元',
                '传感单元支持LoRa/ZigBee/微功率无线可选',
                '-25℃~120℃温度测量范围、±2℃测量精度、±0.1℃分辨率',
                '支持有源/无源模式',
                '汇集单元支持4路无源节点输出、2路开关量采集、1路温湿度传感器接入',
                '汇集单元通信方式：RS485（默认）、4G/GPRS/LoRa/微功率无线（可选）']
            },
            {
              id: '3223',
              model: 'YK-9300',
              name: '微环境监测装置',
              image: require('../../assets/img/hardware/yk9300.png'),
              detail: ['本产品用于局部空间的环境参数精细化测量和调控',
                '支持采集温湿度、水浸、门开关状态、接点状态',
                '就地数据分析、对环境进行除湿、排水等控制 ',
                '终端与传感器之间基于433M无线通信',
                '监测主机通信方式：RS485（默认）、GPRS/LoRa（可选）']
            },
            {
              id: '3224',
              model: 'YK-9400',
              name: '变压器铁芯接地在线监测装置',
              image: require('../../assets/img/hardware/yk9400.png'),
              detail: ['实时监测铁心接地电流值',
                '接地电流报警值可设置，当接地电流值超过设定值后报警，故障消失后停止报警',
                '1mA 10A测量范围，1mA的高分辨率',
                'IP68防护等级',
                '-20℃~70℃工作温度',
                '通信方式：RS485（默认）、4G/GPRS/LoRa/ZigBee/微功率无线（可选）']
            }
          ]
        },
        {
          id: '323',
          param: 'smart',
          name: '智能类',
          data: [
            {
              id: '3231',
              model: 'YK-6110',
              name: '通讯管理机',
              image: require('../../assets/img/hardware/yk6110.png'),
              detail: ['工业级ARM9处理器、Linux系统',
                '支持1路10/100M自适应网口、支持2路RS485接口、1路4G/GPRS接口',
                '下行支持ModbusRTU、ModbusTCP、IEC60870-5-101、DL/T645、私有协议',
                '上行支持ModbusRTU、ModbusTCP、IEC60870-5-101、IEC60870-5-104、MQTT、私有协议']
            },
            {
              id: '3232',
              model: 'YK-6120',
              name: '通讯管理机',
              image: require('../../assets/img/hardware/yk6120.png'),
              detail: ['工业级Cortex-A8/国产工业级四核Cortex-A7处理器、Linux系统',
                '支持2路10/100M自适应网口、支持2/4/6/8路RS485接口',
                '支持1路4G/GPRS接口、支持1路CAN接口',
                '可选配内置GPS/BD定位对时模块',
                '下行支持ModbusRTU、ModbusTCP、IEC60870-5-101、IEC60870-5-104、DL/T645、私有协议',
                '上行支持ModbusRTU、ModbusTCP、IEC60870-5-101、IEC60870-5-104、MQTT、私有协议']
            },
            {
              id: '3233',
              model: 'YK-6210',
              name: '总线通信网关',
              image: require('../../assets/img/hardware/yk6210.png'),
              detail: ['支持1路10/100M自适应网口',
                '支持1路RS485接口、最大支持128个智能总线控制器',
                '无线通信WIFI/GPRS/LoRa/ZigBee/蓝牙/微功率无线（可选）',
                '支持1路程序升级更新USB接口']
            },
            {
              id: '3234',
              model: 'YK-6220',
              name: '智能总线控制器',
              image: require('../../assets/img/hardware/yk6220.png'),
              detail: ['支持1路YK-BUS总线、最大支持64个YK-BUS总线设备',
                '支持1路RS485接口接入总线通信网关',
                '具有配置数据备份模块']
            },
            {
              id: '3235',
              model: 'YK-6230',
              name: '智能继电器模块',
              image: require('../../assets/img/hardware/yk6230.png'),
              detail: ['YK-BUS总线设备',
                '支持4路继电器输出、40A阻性/16A感性/4A荧光灯/16A白炽灯负载',
                '大于10万次开关寿命']
            },
            {
              id: '3236',
              model: 'YK-6300',
              name: '无线自组网模块',
              image: require('../../assets/img/hardware/yk6300.png'),
              detail: ['433MHz/470MHz/2.4GHz微功率发射，可调节，功耗低、抗干扰能力强',
                '半双工通讯，空中收/发自动转换',
                '内嵌 MESH 分布式自组网协议，每次通讯都有多重握手确认，确保数据的稳定',
                '通信频率任意设置，32个辅助信道，自动跳频，有效避免干扰',
                '通讯协议转换及射频收发切换自动完成，用户无须干预，简单易用',
                '通讯距离500m-2km']
            }
          ]
        },
        {
          id: '324',
          param: 'secure',
          name: '安防类',
          data: [
            {
              id: '3241',
              model: 'YK-4110',
              name: '红外半球网络高清摄像机',
              image: require('../../assets/img/hardware/yk4110.png'),
              detail: ['最高分辨率可达2M(1920×1080 @ 30fps)',
                '支持低码率、低延时',
                'H.265高效压缩，节省带宽和存储空间',
                '支持多行OSD,OSD颜色、大小自选',
                '支持3D数字降噪, 支持DWDR',
                '支持自动电子快门功能,适应不同监控环境',
                '支持走廊模式，增加纵向狭长环境下监控区域',
                '支持多种智能报警',
                '支持Smart IR，防止夜间红外过曝',
                '高效红外灯,使用寿命长,照射距离20-30米',
                'ICR红外滤片式自动切换,实现真正的日夜监控',
                '支持PoE供电功能（选配）',
                '支持GB28181接入,支持Onvif接入',
                '支持Email、NTP服务',
                '支持HTTPS加密传输']
            },
            {
              id: '3242',
              model: 'YK-4120',
              name: '红外枪型网络高清摄像机',
              image: require('../../assets/img/hardware/yk4120.png'),
              detail: ['最高分辨率可达2M(1920×1080 @ 30fps)',
                '支持低码率、低延时',
                'H.265高效压缩，节省带宽和存储空间',
                '支持多行OSD,OSD颜色、大小自选',
                '支持3D数字降噪, 支持DWDR',
                '支持自动电子快门功能,适应不同监控环境',
                '支持走廊模式，增加纵向狭长环境下监控区域',
                '支持多种智能报警',
                '支持Smart IR，防止夜间红外过曝',
                '高效红外灯,使用寿命长,照射距离40-50米',
                'ICR红外滤片式自动切换,实现真正的日夜监控',
                '支持PoE供电功能（选配）',
                '支持GB28181接入,支持Onvif接入',
                '支持Email、NTP服务',
                '支持HTTPS加密传输']
            },
            {
              id: '3243',
              model: 'YK-4200',
              name: '高清人脸识别终端',
              image: require('../../assets/img/hardware/yk4200.png'),
              detail: ['最高分辨率可达2M(1920X1080@30fps)',
                '采用三维造型，工业级设计，俯仰角度、左右旋转可调',
                '一体机完成人脸抓拍、比对功能',
                '支持活体检测，有效防止照片、视频等欺骗',
                '人脸识别距离范围大',
                '采用多任务级联卷积神经网络的人脸检测技术',
                '采用深度学习算法，人脸库可达10000个',
                '导入人脸模板灵活，支持单张、批量图片文件导入和实时抓拍导入',
                '提供登录后查询、设置一体机参数，查看实时监控和人脸比对画面',
                '支持普通人员、白名单人员、黑名单人员等人脸类型',
                '在断网模式下可以单机运行',
                '提供485、I/O输入输出、韦根等外设接口']
            },
            {
              id: '3244',
              model: 'YK-4300',
              name: '16路5MP全实时网络硬盘录像机',
              image: require('../../assets/img/hardware/yk4300.png'),
              detail: ['最大16路全实时500MP视频接入, 1U机箱NVR',
                'H.265/H.264双码流解码，嵌入式Linux操作系统',
                '支持同步录像、远程监看、备份',
                'HDMI输出，支持 1080P高清预览',
                '支持预览图像与回放图像12倍电子放大',
                '标准ONVIF、RTSP、GB28181协议',
                '报警抓拍、报警邮件发送功能',
                '支持DDNS、EMAIL、UPNP、NTP、P2P等功能',
                '支持WEB、手机监看、客户端、CMS监控',
                '支持外部报警、',
                '支持我司SMART IPC 目标计数、物品检测、区域检测、虚拟警戒线、',
                '支持磁盘分组配额、和磁盘盘组两种存储模式，可对不同的通道分配不同的录像保存容量或周期',
                '支持IPC集中管理，包括IPC参数配置、信息导入导出、信息实时获取和升级等功能',
                '支持通道分组，预览轮巡',
                '支持网络检测（网络流量监控、网络抓包、网络通畅）功能',
                '支持最大8路子码流录像同步回放和多路同步倒放',
                '支持即时回放功能',
                '全新的UI操作界面，支持一键开启录像功能',
                '支持双密码鉴权功能']
            }
          ]
        }
      ],
      data: '',
      detail: '',
      dictPage: {'321': 0, '322': 1, '323': 2, '324': 3}
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    if (this.$route.query.page) {
      let sel = this.dictPage[this.$route.query.page]
      this.selMenu = sel
      this.data = this.dataList[sel].data
    } else {
      this.$router.push({query: {page: '321'}})
    }
  },
  watch: {
    $route: {
      handler() {
        this.clickMenuExternal(this.$route.query.page)
      },
      deep: true
    }
  },
  methods: {
    clickMenuExternal(page) {
      document.documentElement.scrollTop = 0
      this.data = this.dataList[this.dictPage[page]].data
    }
  }
}
</script>
<style scoped>
  .menu-class {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #efefef;
    color: #000000;
    cursor: pointer;
  }
  .menu-class-hover {
    width: 85%;
    margin-top: 10px;
    height: 40px;
    line-height: 40px;
    background-color: #00bf86;
    color: #ffffff;
    cursor: pointer;
  }
  .menu-class:hover {
    background-color: #00bf86;
    color: #ffffff;
  }
  .model-class {
    height: 40px;
    line-height: 40px;
    color: #000000;
    font-size: 16px;
    cursor: pointer;
  }
  .model-class:hover {
    color: #00bf86;
  }
  .model-class-ext {
    height: 40px;
    line-height: 40px;
    color: #000000;
    font-size: 16px;
  }
  .text-class {
    height: 30px;
    line-height: 30px;
    color: #000000;
    font-size: 14px;
  }
  .img-class {
    width: 50%;
    height: 100%;
  }
  .detail-class {
    width: 94%;
    margin-left: 3%;
    text-align: justify;
    white-space: pre-wrap;
    text-indent: 2em;
    height: 240px;
    line-height: 30px;
    overflow-y: auto;
    font-size: 14px;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/Hardware.vue